import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useUpdateEffect } from '@cian/react-utils';
export function useDropdownController(_ref) {
  var disabled = _ref.disabled,
    readOnly = _ref.readOnly;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var canOpen = !disabled && !readOnly;
  var openDropdown = function openDropdown() {
    if (canOpen) {
      setOpen(true);
    }
  };
  var closeDropdown = function closeDropdown() {
    return setOpen(false);
  };
  var toggleDropdown = function toggleDropdown() {
    setOpen(function (open) {
      if (open) {
        return false;
      } else {
        return canOpen ? true : false;
      }
    });
  };
  useUpdateEffect(function () {
    if (!canOpen) {
      closeDropdown();
    }
  }, [canOpen]);
  return {
    open: open,
    actions: {
      openDropdown: openDropdown,
      closeDropdown: closeDropdown,
      toggleDropdown: toggleDropdown
    }
  };
}